import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from 'src/themes/Theme';

export const Theme = ({ children }) => <ThemeProvider theme={theme}>{children}</ThemeProvider>;
